'use client';
import { useTranslations } from 'next-intl';
import { Selector } from '../../../../../SelectorGroup/index';

type TablesMultiplierProps = {
  multipliers: number[];
  selectedMultiplier: number;
  setSelectedMultiplier: (multiplier: number) => void;
};

/**
 * Renders multipliers, in the proper container, with selected value and update function
 * @param multipliers - list of multipliers to render
 * @param selectedMultiplier - currently selected multiplier value
 * @param setSelectedMultiplier - multiplier update function to be executed on click
 * @returns HTMLDivElement with number of multipliers rendered
 */
function TablesMultiplier({ multipliers, selectedMultiplier, setSelectedMultiplier }: TablesMultiplierProps) {
  const t = useTranslations('lotteries.results');

  return (
    <div className="flex gap-1" data-track-container="Filters">
      {multipliers.map(multiplier => (
        <Selector
          key={multiplier}
          value={multiplier}
          selected={selectedMultiplier === multiplier}
          onClick={() => setSelectedMultiplier(multiplier)}
          className="flex justify-center paragraph-explanatory-strong text-center"
          data-track-name={t(`results_multiplier`, { multiplier })}
        >
          {t(`results_multiplier`, { multiplier })}
        </Selector>
      ))}
    </div>
  );
}

export { TablesMultiplier };
